const newsRouter = {
  path: '/news',
  component: () => import('@/views/cms/news/parent'), // Parent router-view
  name: 'news',
  redirect: '/news/table',
  meta: {
    title: '新闻资讯管理',
    icon: 'el-icon-reading',
    roles: ['root', 'market', 'business']
  },
  children: [
    {
      path: 'add',
      name: 'NewsAdd',
      component: () => import('@/views/cms/news/add'),
      meta: { title: '新闻资讯添加', icon: 'el-icon-circle-plus-outline', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'table',
      name: 'NewsTable',
      component: () => import('@/views/cms/news/index'),
      meta: { title: '新闻资讯列表', icon: 'el-icon-files', roles: ['root', 'market', 'business'], noCache: false }
    },
    {
      path: 'category',
      name: 'NewsCategory',
      component: () => import('@/views/cms/news/category'),
      meta: { title: '新闻分类管理', icon: 'el-icon-menu', roles: ['root', 'market', 'business'], noCache: true }
    },
    {
      path: 'edit',
      name: 'NewsEdit',
      component: () => import('@/views/cms/news/edit'),
      meta: { title: '新闻资讯编辑', icon: 'el-icon-menu', roles: ['root', 'market', 'business'], noCache: true },
      hidden: true
    }
  ]
}
export default newsRouter
